import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVertRounded';
import { Icon } from '@mui/material';
import { useNavigate } from 'react-router-dom';




const ITEM_HEIGHT = 48;

const  ExpoRichiesteMenu = ({id_soggetto}) =>{

  const navigate=useNavigate();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

const handleModifica = () => {
       navigate("/expo_richiestaAccept",{state:{ modo: 'edit', soggetto:id_soggetto, chiamante: "expo_richieste_admin" }});

  };
const handleVisualizzaPdf = () => {
       navigate("/expo_richiestaPDFVis",{state:{ modo: 'vis', soggetto:id_soggetto, chiamante: "expo_richieste_admin" }});

  };
  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: '20ch',
            },
          },
          list: {
            'aria-labelledby': 'long-button',
          },
        }}
      >
    
        <MenuItem disableRipple onClick={handleModifica}>
    
          <Icon>edit</Icon>
         &nbsp;&nbsp;Modifica 
        </MenuItem>
       <MenuItem disableRipple onClick={handleVisualizzaPdf}>
    
          <Icon>visibility</Icon>
         &nbsp;&nbsp;Vedi PDF 
        </MenuItem>
      </Menu>
    </div>
  );
}


export default ExpoRichiesteMenu;